import { computed } from '@vue/composition-api';
import { useCommonColumns } from '@/views/Brand/Applications/Offer/Details/composables/use-common-columns';
import { useAcceptanceColumns } from '@/views/Brand/Applications/Offer/Details/composables/use-acceptance-columns';
export const useContractColumns = (ctx, offer, contract, shownYear) => {
    const { commonColumns } = useCommonColumns(ctx, {
        offer,
        contract: true,
        shownYear,
        useOfferObjectDetails: true,
    });
    const { acceptanceColumns } = useAcceptanceColumns(ctx, {
        offer,
        isReadOnlyAcceptance: true,
    });
    const columns = computed(() => {
        const yearValue = shownYear != null
            ? typeof shownYear === 'number'
                ? shownYear
                : shownYear.value
            : 0;
        return [
            ...commonColumns.value,
            {
                field: 'id',
                colId: 'cost',
                headerName: ctx.root.$t('offer-costs.totalCost').toString(),
                cellRenderer: 'TotalCostCell',
                cellRendererParams: (params) => {
                    const summaryCell = !!params?.node?.rowPinned;
                    const cost = summaryCell
                        ? contract.value?.totalSum
                        : Array.from(params?.data?.availability?.reduce((monthMap, availability) => {
                            if (yearValue !== 0 && availability.year !== yearValue) {
                                return monthMap;
                            }
                            monthMap.set(`${availability.year}-${availability.month}`, availability);
                            return monthMap;
                        }, new Map()) || [])
                            .map(([, availability]) => availability.local?.price || 0)
                            .reduce((price, sum) => price + sum, 0);
                    return {
                        cost,
                        summaryCell,
                        isIndefinite: offer.isIndefinite,
                    };
                },
                width: 230,
                pinned: 'right',
                suppressMovable: true,
            },
            ...(offer.isApprovalRequired ? acceptanceColumns : []),
        ];
    });
    return { columns };
};
